import { render } from "./SzTreeCollapse.vue?vue&type=template&id=c18d03f0&scoped=true"
import script from "./SzTreeCollapse.vue?vue&type=script&lang=ts"
export * from "./SzTreeCollapse.vue?vue&type=script&lang=ts"

import "./SzTreeCollapse.vue?vue&type=style&index=0&id=c18d03f0&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-c18d03f0"

export default script